import { Capacitor } from '@capacitor/core';
import { Filesystem } from '@capacitor/filesystem';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { PushNotifications } from '@capacitor/push-notifications';
import { Camera, CameraSource, CameraResultType } from '@capacitor/camera';
import { VoiceRecorder } from 'capacitor-voice-recorder';
import Api from '../ajax';

export const requestMic = async () => {
  const { value } = await VoiceRecorder.requestAudioRecordingPermission();

  if (value) {
    return value;
  }
};

export const checkVideoPermissions = async () => {
  const cameraStatus = await Camera.checkPermissions();

  if (cameraStatus.camera === 'granted') {
    return true;
  }
  const req = await Camera.requestPermissions(['camera']);

  return req.camera === 'granted';
};

// Unified camera and mic permission request for native platforms
export async function requestCameraAndMicPermissions() {
  try {
    const cameraGranted = await checkVideoPermissions();
    const micGranted = await requestMic();

    return !!cameraGranted && !!micGranted;
  } catch (e) {
    return false;
  }
}

export async function requestStoragePermission() {
  try {
    await Filesystem.checkPermissions();
    await Filesystem.requestPermissions();
  } catch (e) {
    console.error('❌ Storage permission denied or failed', e);
  }
}

export async function openCamera() {
  if (Capacitor.getPlatform() === 'android') {
    const permission = await Camera.checkPermissions();

    if (permission.camera !== 'granted') {
      const request = await Camera.requestPermissions();

      if (request.camera !== 'granted') {
        alert('Camera permission required');

        return;
      }
    }

    return await Camera.getPhoto({
      quality: 90,
      allowEditing: false,
      correctOrientation: true,
      source: CameraSource.Camera,
      resultType: CameraResultType.Uri,
      saveToGallery: false,
    });
  }
}

// export async function startVoiceRecording() {
//   const { value } = await VoiceRecorder.requestAudioRecordingPermission();

//   if (!value) {
//     alert("Microphone permission denied");
//     return;
//   }

//   await VoiceRecorder.startRecording();
// }

// export async function stopVoiceRecording() {
//   const result = await VoiceRecorder.stopRecording();
// }


let listenersInitialized = false;

// Unified notification permission and listener setup for both platforms
export async function requestNotificationPermission(mobileDeviceInfo) {
  if (!Capacitor.isNativePlatform() || listenersInitialized) return;
  listenersInitialized = true;

  const api = new Api();

  // Listen for FCM token (initial + refresh)
  await FirebaseMessaging.addListener('tokenReceived', (event) => {
    window.__apnsTokenReceived = true;
    if (mobileDeviceInfo) {
      api.post('/fcm-register-mobile', {
        ntoken: event.token,
        device_info: mobileDeviceInfo,
        notification: 'E',
        is_MobileApp: 'M',
      });
    } else {
      console.warn('⚠️ No device info available to save token');
    }
  });

  // Listen for notification tap
  await FirebaseMessaging.addListener('notificationActionPerformed', (_event) => {
    // Optionally handle notification tap
  });

  try {
    // iOS: Request APNS permission and register
    if (Capacitor.getPlatform() === 'ios') {
      const perm = await PushNotifications.requestPermissions();

      if (perm.receive === 'granted') {
        await PushNotifications.register();
        await new Promise(resolve => setTimeout(resolve, 500));
      }
    }

    // Request FCM permission (both platforms)
    const status = await FirebaseMessaging.requestPermissions();

    if (status.receive !== 'granted') {
      console.warn('⚠️ Notification permission not granted');

      return;
    }

    // Get FCM token (triggers tokenReceived listener)
    try {
      const { token } = await FirebaseMessaging.getToken();

      if (token && mobileDeviceInfo) {
        api.post('/fcm-register-mobile', {
          ntoken: token,
          device_info: mobileDeviceInfo,
          notification: 'E',
          is_MobileApp: 'M',
        });
      }
    } catch (e) {
      console.warn('⚠️ Token not ready yet');
    }
  } catch (error) {
    console.error('❌ Notification permission error:', error);
  }
}
